/** Converts a number to scientific notation string. Keeps all available decimals and formats exponent as E+XX. */
export function numberToScientific(value: number, locale: string = 'en'): string {
	if (value === 0) {
		return locale === 'en' ? '0.00E+00' : '0,00E+00';
	}

	// 1. Get standard exponential string to find the correct exponent
	// We use a high precision or default to get all decimals
	const splitValue = value.toExponential().split('e');
	let coefficient = splitValue[0];
	const exponent = Number.parseInt(splitValue[1], 10);

	// 2. Ensure the coefficient has at least two decimal places
	// If it's an integer like "7", make it "7.00"
	if (!coefficient.includes('.')) {
		coefficient += '.00';
	} else {
		const decimalPart = coefficient.split('.')[1];
		if (decimalPart.length === 1) {
			coefficient += '0'; // "7.4" becomes "7.40"
		}
	}

	// 3. Format the exponent
	// Math.abs handles the "E+" requirement, padStart handles the "two digit" requirement
	const sign = exponent < 0 ? '' : '+';
	const formattedExponent = `${sign}${exponent.toString().padStart(2, '0')}`;
	const scientific = `${coefficient}E${formattedExponent}`;
	// if the locale is "en", we replace "," with "."
	const localized = locale === 'en' ? scientific : scientific.replace('.', ',');
	return localized;
}
